import styled from 'styled-components';
import { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import SecondsCounter from './SecondsCounter';
import OnBoardingModal from './OnBoardingModal';
import images from '../../../images';
import CountdownModal from './CountdownModal';

import clockIcon from '../../../images/Clock.png';

const Container = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 35px;
`;

const CountDownContainer = styled.div`
  position: fixed;
  display: flex;
  top: 0%;
  right: 6%;
  flex-direction: row;
`;

const TimerImage = styled.img`
  height: 6.66vw;
  width: 6.66vw;
  margin-top: 30%;
  margin-left: 5%;
  scale: 0.7;
`;

const CloseButton = styled.img`
  height: 5vw;
  width: 5vw;
  border-radius: 50%;
  position: fixed;
  top: 2.8%;
  left: 6%;
`;

const TopContainer = styled.div`
  position: fixed;
  display: flex;
  top: 3%;
  justify-content: space-between;
  flex-direction: row;
`;

const Card = styled.div`
  overflow-y: hidden;
  position: fixed;
  width: 85%;
  overflow-x: hidden;
  height: 50%;
  padding: 5px;
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 85%;
  max-height: 62%;
  will-change: transform;
  border-radius: 10px;
  box-shadow:
  2px 2px 10px 2px rgba(0, 0, 0, 0.2);
`;

const MaterialImage = styled.img`
  height: 40vh;
  width: 90%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const MaterialName = styled.h2`
  text-align: center;
  font-size: 3.33vh;
  margin-top: 5%;
  transform: translateY(-25px);
`;

const ButtonsContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 1%;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  transform: translate(50%, -100%);
`;

const ButtonImage = styled.img`
  height: 7vh;
  width: 7vh;
  border-radius: 50%;
  background-color: #efefef;
  background-size: contain;
  background-position: center;
  display: block;
  margin: 0 auto;
`;

/**
 * This compoent is used for two different parts:
 *
 * The first part is to be a background of the on boarding modal
 *
 * The seond part is to be a background for time out modal
 *
 */

const StaticGameScreen = (
  {
    questionIndex,
    currentLevel,
    modalVisible,
    doneMaterials,
    passedMaterialsCount,
    isOnBoarding,
    ButtonState,
    onPressRecycable,
    onPressNotRecycable,
    recycleRightData,
    isCountDown,
    rrGameOnly
  }
) => {
  const CountDownRectangle = styled.div`
    position: fixed;
    top: ${(Number(window.innerHeight / window.innerWidth) * -1.88 + 6.375)}%;
    right: 4.5%;
    height: 6.66vw;
    width: 20vw;
    background-color: #48802A;
    border-radius: 4vw;
  `;

  return (
    <Container>
      {isOnBoarding && !isCountDown && (
        <OnBoardingModal
          questionIndex={questionIndex}
          currentLevel={`level_${currentLevel + 1}_materials`}
          modalVisible={modalVisible}
          doneMaterials={doneMaterials}
          passedMaterialsCount={passedMaterialsCount}
          ButtonState={ButtonState}
          onPressRecycable={onPressRecycable}
          onPressNotRecycable={onPressNotRecycable}
        />
      )}
      {isCountDown && (
        <CountdownModal
          questionIndex={questionIndex}
          currentLevel={`level_${currentLevel + 1}_materials`}
          modalVisible={modalVisible}
          doneMaterials={doneMaterials}
          passedMaterialsCount={passedMaterialsCount}
        />
      )}
      <TopContainer>
        {!rrGameOnly && <CloseButton role="button" tabIndex={0} src={images.close} alt="Close" />}
        <CountDownRectangle />
        <CountDownContainer>
          <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} />
          <TimerImage
            src={clockIcon}
            alt="Timer"
          />
        </CountDownContainer>
      </TopContainer>
      <Levels
        levels={recycleRightData}
        currentLevelKey={`level_${currentLevel + 1}_materials`}
        modalVisible={modalVisible}
      />
      <>
        <CardContainer>
          <Card>
            <MaterialImage
              src={recycleRightData[`level_${currentLevel + 1}_materials`][questionIndex].mat_image}
              alt={recycleRightData[`level_${currentLevel + 1}_materials`][questionIndex].mat_nm || 'Material image'}
            />
            <MaterialName>
              {recycleRightData[`level_${currentLevel + 1}_materials`][questionIndex].mat_nm}
            </MaterialName>

          </Card>
        </CardContainer>

        <ButtonsContainer>
          <ButtonImage role="button" tabIndex={0} alt="Not recyclable" src={images.decline} />
          <ButtonImage role="button" tabIndex={0} alt="Recyclable" src={images.recycable} />
        </ButtonsContainer>
        <GameStatusIndicator
          totalMaterials={recycleRightData[`level_${currentLevel + 1}_materials`]}
          doneMaterials={doneMaterials}
          prevTotalMaterials={passedMaterialsCount}
        />
      </>
    </Container>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.recycleRight.allRrData,
    rrGameOnly: store.app.rrGameOnly
  })
)(StaticGameScreen);
